var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '../text';
import { requiredDotStyle, requiredIndicatorStyle } from './styles';
function RequiredIndicator(_a) {
    var indicator = _a.indicator, isRequired = _a.isRequired, size = _a.size;
    function renderIndicator() {
        if (indicator === 'showOptional' && !isRequired) {
            return 'Optional';
        }
        if (indicator === 'showRequired' && isRequired) {
            return (_jsxs(_Fragment, { children: [_jsx("span", { css: requiredDotStyle({ size: size }) }), "Required"] }));
        }
        return null;
    }
    return (_jsx(Text, __assign({ "aria-hidden": true, css: requiredIndicatorStyle({ size: size }) }, { children: renderIndicator() })));
}
export default RequiredIndicator;
